/** Resolve a backend-relative media path to a full URL.
 *
 * Image URLs come from the DB in three shapes:
 *   1. `/static/...`                              (relative path)
 *   2. `https://<frontend-host>/static/...`       (legacy absolute URL written
 *      when the frontend and `/static/*` lived on the same origin)
 *   3. `https://<other-host>/...`                 (external, used as-is)
 *
 * Since the 2026-05-17 Cloudflare Pages migration the frontend is hosted on
 * cloudmaster.fr / www.cloudmaster.fr (Pages) while `/static/*` is served by
 * the API host (api.cloudmaster.fr / api.dev.cloudmaster.fr). Shape #2 now
 * lands on Pages → 404, so we rewrite any `<frontend-host>/static/...` URL
 * onto the API base.
 */
const API_BASE = (import.meta.env.VITE_API_URL as string | undefined) || '';

const FRONTEND_HOST_PATTERN =
  /^https:\/\/(www\.|dev\.|qa\.)?cloudmaster\.fr(?=\/static\/)/;

export function resolveMediaUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  if (url.startsWith('/static/')) return `${API_BASE}${url}`;
  if (FRONTEND_HOST_PATTERN.test(url)) return url.replace(FRONTEND_HOST_PATTERN, API_BASE);
  return url;
}
